import { motion } from "framer-motion";
import {
  Mountain, Car, Tv, Sofa, UtensilsCrossed, MapPin,
  Building, Wifi, Home
} from "lucide-react";

const amenities = [
  { icon: Mountain, label: "Mountain View Balcony" },
  { icon: Home, label: "Terrace" },
  { icon: Car, label: "Free Private Parking" },
  { icon: UtensilsCrossed, label: "Fully Equipped Kitchen" },
  { icon: MapPin, label: "Perfect Location" },
  { icon: Tv, label: "TV" },
  { icon: Sofa, label: "Sofa Bed & Dining Area" },
  { icon: Building, label: "Modern Building" },
];

const AmenitiesSection = () => {
  return (
    <section id="features" className="py-24 md:py-32 px-6 md:px-16">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <p className="text-muted-foreground font-body text-sm tracking-[0.3em] uppercase mb-3">
            What's included
          </p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground">
            Everything you need
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20">
          {amenities.map((item, i) => (
            <motion.div
              key={item.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-card border border-border rounded-xl p-6 hover:border-foreground/20 transition-colors group"
            >
              <item.icon className="w-6 h-6 text-foreground mb-4 group-hover:scale-110 transition-transform" />
              <p className="font-body text-sm font-medium text-foreground">{item.label}</p>
            </motion.div>
          ))}
        </div>

        {/* Pricing */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-10"
        >
          <p className="text-muted-foreground font-body text-sm tracking-[0.3em] uppercase mb-3">
            Flexible stays
          </p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground">
            Pricing
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {[
            { duration: "1 night", price: "€40" },
            { duration: "3 nights", price: "€110" },
            { duration: "7 nights", price: "€250" },
            { duration: "2 weeks", price: "€500" },
            { duration: "1 month", price: "€1,000" },
          ].map((tier, i) => (
            <motion.div
              key={tier.duration}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-card border border-border rounded-xl p-6 text-center hover:border-foreground/20 transition-colors"
            >
              <p className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-1">{tier.price}</p>
              <p className="font-body text-sm text-muted-foreground">{tier.duration}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AmenitiesSection;
